window.addEventListener("finishQuiz", function (e) {
    const plan = e.detail.winner;
    const saved = localStorage.getItem("quiz_responses_v2");
    const {meal_split, pk_qty} = JSON.parse(saved);
  // Funções de custo unitário por plano
  const mealPrices = {
    power: { pk: 18.65, home: 11.0, takeout: 25.0, dineout: 40.0 },
    "pro-athlete": { pk: 22.73, home: 15.0, takeout: 30.0, dineout: 45.0 },
    "low-carb": { pk: 19.19, home: 11.0, takeout: 25.0, dineout: 40.0 },
    "lean-muscle": { pk: 19.19, home: 11.0, takeout: 25.0, dineout: 40.0 },
    "clean-bulking": { pk: 28.02, home: 20.0, takeout: 40.0, dineout: 50.0 },
  };

  function getMealCost(plan, type) {
    return mealPrices[plan]?.[type] || 0;
  }

  // Tempo gasto cozinhando
  function calcTimeSpentCooking(totalHomeMeals, timePerMeal = 45) {
    return totalHomeMeals * timePerMeal;
  }

  // Dinheiro economizado
  function calcMoneySaved({
    totalPK,
    totalHome,
    totalTakeout,
    costPK,
    costHome,
    costTakeout,
  }) {
    let homeAfterPK = totalHome;
    let takeoutAfterPK = totalTakeout;

    if (totalPK >= totalTakeout) {
      homeAfterPK = Math.max(0, totalHome - (totalPK - totalTakeout));
      takeoutAfterPK = 0;
    } else {
      takeoutAfterPK = totalTakeout - totalPK;
    }

    const costBefore = totalHome * costHome + totalTakeout * costTakeout;
    const costAfter =
      homeAfterPK * costHome + takeoutAfterPK * costTakeout + totalPK * costPK;

    return {
      moneySaved: costBefore - costAfter,
      homeAfterPK,
      takeoutAfterPK,
      costHomeAfterPK: homeAfterPK * costHome,
      costTakeoutAfterPK: takeoutAfterPK * costTakeout,
    };
  }

  // Tempo economizado
  function calcTimeSaved({ totalHome, homeAfterPK, timePerMeal = 45 }) {
    return totalHome * timePerMeal - homeAfterPK * timePerMeal;
  }

  ///////////////////////////////////
  // Exemplo de uso
  ///////////////////////////////////

  const totalPK = parseInt(pk_qty) || 0;
  const totalHome = parseInt(meal_split.split[0]) || 0;
  const totalTakeout = parseInt(meal_split.split[1]) || 0;
  const totalDineOut = parseInt(meal_split.split[2]) || 0;
  const timePerMeal = 45;

  // Custos unitários
  const costPK = getMealCost(plan, "pk");
  const costHome = getMealCost(plan, "home");
  const costTakeout = getMealCost(plan, "takeout");
  const costDineOut = getMealCost(plan, "dineout");

  console.log("Total Meals:", totalPK, "costPK", costPK);

  // Custos totais atuais
  const costPKTotal = totalPK * costPK;
  const costHomeTotal = totalHome * costHome;
  const costTakeoutTotal = totalTakeout * costTakeout;
  const costDineOutTotal = totalDineOut * costDineOut;
  const costCurrent = costHomeTotal + costTakeoutTotal;

  const timeCooking = calcTimeSpentCooking(totalHome, timePerMeal);

  const {
    moneySaved,
    homeAfterPK,
    takeoutAfterPK,
    costHomeAfterPK,
    costTakeoutAfterPK,
  } = calcMoneySaved({
    totalPK,
    totalHome,
    totalTakeout,
    costPK,
    costHome,
    costTakeout,
  });

  const timeSaved = calcTimeSaved({ totalHome, homeAfterPK, timePerMeal });


  ///////////////////////////////////
// Output
///////////////////////////////////
console.log("==== ANTES DA POWER KITCHEN ====");
console.log(`Cooked at Home: ${totalHome}`);
console.log(`Takeout: ${totalTakeout}`);
console.log(`Total Meals: ${totalHome + totalTakeout}`);
console.log(`Total Cost: $${costCurrent.toFixed(2)}`);
console.log(`Time Spent Cooking: ${timeCooking} min`);

console.log("\n==== DEPOIS DA POWER KITCHEN ====");
console.log(`Cooked at Home: ${homeAfterPK}`);
console.log(`Takeout: ${takeoutAfterPK}`);
console.log(`PK Meals: ${totalPK}`);
console.log(`Total Meals: ${homeAfterPK + takeoutAfterPK + totalPK}`);
console.log(`Total Cost: $${(costHomeAfterPK + costTakeoutAfterPK + costPKTotal).toFixed(2)}`);
console.log(`Time Saved: ${timeSaved} min`);

console.log("\n==== ECONOMIA ====");
console.log(`Money Saved: $${moneySaved.toFixed(2)}`);
console.log(`Time Saved: ${timeSaved} min`);

// Recupera o que já existe no localStorage
let responsesObj = JSON.parse(localStorage.getItem("quiz_responses_v2")) || {};

// Atualiza/adiciona o plano atual sem apagar os outros
responsesObj["saving"] = {
    totalMeals_PowerKitchen: totalPK,
    totalMeals_CookedAtHome: homeAfterPK,
    totalMeals_Takeout : takeoutAfterPK,
    totalMeals_DineOut : totalDineOut,
    timeSpend_CookedAtHome : timeCooking,
    costMeals_PowerKitchen : costPKTotal,
    costMeals_CookedAtHome : costHomeAfterPK,
    costMeals_Takeout : costTakeoutAfterPK,
    costMeals_DiningOut : costDineOutTotal,
    costOfCooking : costHomeTotal,
    costOfTakeout : costTakeoutTotal,
    costCurrent : costCurrent.toFixed(2),
    moneySaved : moneySaved.toFixed(2),
    timeSpentCooking : timeCooking.toFixed(2),
    timeSaved : timeSaved.toFixed(2)

};

// Salva novamente
localStorage.setItem("quiz_responses_v2", JSON.stringify(responsesObj));
});
